import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ForecastSettingPopupComponent } from '../forecast-setting-popup/forecast-setting-popup.component';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { AppService } from '../../../../../../app/app.service';
import { Family, Customer, JobSite, Equipment, Make, Model, SearchFavorite, favPopUpModel, FavOperation, SearchItem, SelectionLists, CurrentSelection } from '../../../../../../app/entities';
import { CustomeEvaluationRangeVM } from '../../../../../../app/modules/CustomEval/custom-eval.model';
import { CustomEvalService } from '../../../../../../app/modules/CustomEval/custom-eval.service';
import { MakeViewModel } from '../../../../../../app/modules/manage-components/manage-components.model';
import { ManageComponentsService } from '../../../../../../app/modules/manage-components/manage-components.service';
import { PreferencesService } from '../../../../../../app/modules/preferences/preferences.service';
import { UcFleet, UcFleetEquipmentDetail, ColumnList, UcPlannerGrapCompVm, UcPlannerGrapVm, GraphComponentData, UcPlannerGrapHeadingsVm, GraphHeaderData, MonthlyQuoteSummaryVM, MonthlyQuoteSummary, WeeklyQuoteSummary } from '../../../../../../app/modules/setup-equipment/setup-equipment.model';
import { SetupEquipmentService } from '../../../../../../app/modules/setup-equipment/setup-equipment.service';
import { SetupModelsService } from '../../../../../../app/modules/setup-models/setup-models.service';
import { GenericIdName } from '../../../../../../app/shared/models/common-search-filters.model';
import { SharedService } from '../../../../../../app/shared/services/SharedService';
import { TranslateService } from '../../../../../../app/translate';
import { DisplaySettingsPopupComponent } from '../SettingsPopup/display-settings-popup/display-settings-popup.component';

@Component({
  selector: 'app-ucplanner-new',
  templateUrl: './ucplanner-new.component.html',
  styleUrls: ['./ucplanner-new.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]
})
export class UcplannerNewComponent implements OnInit {

  @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger1: MatAutocompleteTrigger;
  myControl = new FormControl();
  customerTitle: string;
  JobsiteId: number;
  CustomerId: number;
  MakeViewModel: MakeViewModel[] = [];
  filteredMakeViewModel: MakeViewModel[] = [];
  _dropDownFamilyFiltered: Family[];
  familyList: Family[] = [];
  familyTitle: string;
  familyId: number = 0;
  isSearchVisible: boolean = true;
  //ModelList: Model[] = [];
  //filteredModels: Model[] = [];
  makeTitle: string;
  makeid: string;
  filerModelList: GenericIdName[];
  modalLoding: boolean;
  modelid: string
  selectedJobSite: number;
  make_auto: number
  model_auto: number
   TotalDays: number;
  DaysArr: any[] = [];
  WeekStartDate: Date;
    ucFleet: UcFleet = new UcFleet();
  ucFleetEquipmentDetail: UcFleetEquipmentDetail[] = [];
  FleetTableLoader: boolean;
  IsTableShow: boolean;
  userUOD: string = 'km';
  isOptionsVisible: boolean = true;
  customerCtrl: FormControl;
  jobsiteCtrl: FormControl;
  equipmentCtrl: FormControl;
  selectedComponentType: number = 0;
  familyCtrl: FormControl;
  makeCtrl: FormControl;
  modelCtrl: FormControl;
  filteredCustomers: Observable<Customer[]>;
  filteredJobsites: Observable<JobSite[]>;
  filteredEquipments: Observable<Equipment[]>;
  filteredFamilies: Observable<Family[]>;
  filteredMakes: Observable<Make[]>;
  filteredModels: Observable<Model[]>;
  filteredExaminers: Observable<Customer[]>;
  filteredDealer: Observable<Customer[]>;
  filterMakeModelFamilyForExistingOnly = true;
  timelineStartDate = new Date('2025-07-07');
  timelineEndDate = new Date('2025-09-30');
  barEndDate = new Date('2025-08-06');
  timelineDates: Date[] = [];
  emptyColumns: any[] = [];
  internalLimitedJobSites: JobSite[];
  internalLimitedEquipments: Equipment[];
  internalLimitedModels: Model[];
  internalLimitedCustomers: Customer[];
  UcPlannerGrapVm: UcPlannerGrapVm = new UcPlannerGrapVm();
  uniqueMonths: any[] = [];
  GraphData: GraphComponentData[] = [];
  daysFor100Arr: number[] = [];
  daysFor120Arr: number[] = [];
  recommendationMap = new Map<string, Map<number, any[]>>();
    userLanguage = 'english';
  @ViewChild('scrollableBody') scrollableBody!: ElementRef;
  @ViewChild('stickyHeader') stickyHeader!: ElementRef;

  @ViewChild('autoCompleteCustomer', { static: false, read: MatAutocompleteTrigger }) autoCompleteCustomer: MatAutocompleteTrigger;
  @ViewChild('autoCompleteModel', { static: false, read: MatAutocompleteTrigger }) autoCompleteModel: MatAutocompleteTrigger;
  @ViewChild('auto1', { static: false, read: MatAutocompleteTrigger }) autoCompleteMake: MatAutocompleteTrigger;
  @ViewChild('autoCompleteFamily', { static: false, read: MatAutocompleteTrigger }) autoCompleteFamily: MatAutocompleteTrigger;

  constructor(private _appService: AppService, public _modelService: SetupModelsService, private _notify: NotificationsService,
    private router: Router, private _translate: TranslateService, private _sharedService: SharedService, private _dialog: MatDialog, public _componentService: ManageComponentsService, private _evalService: CustomEvalService, private _planerService: SetupEquipmentService, private datePipe: DatePipe, private _pref: PreferencesService) {
    this.customerCtrl = new FormControl();
    this.jobsiteCtrl = new FormControl();
    this.equipmentCtrl = new FormControl();
    this.familyCtrl = new FormControl();
    this.makeCtrl = new FormControl();
    this.modelCtrl = new FormControl();

  }

  @ViewChild('customerAutoCompleteInput', { read: MatAutocompleteTrigger })
  customerTrigger: MatAutocompleteTrigger;
  @ViewChild('jobSiteAutoCompleteInput', { read: MatAutocompleteTrigger })
  jobSiteTrigger: MatAutocompleteTrigger;
  @ViewChild('equipmentAutoCompleteInput', { read: MatAutocompleteTrigger })
  equipmentTrigger: MatAutocompleteTrigger;
  @ViewChild('makeAutoCompleteInput', { read: MatAutocompleteTrigger })
  makeTrigger: MatAutocompleteTrigger;
  @ViewChild('familyAutoCompleteInput', { read: MatAutocompleteTrigger })
  familyTrigger: MatAutocompleteTrigger;
  @ViewChild('modelAutoCompleteInput', { read: MatAutocompleteTrigger })
  modelTrigger: MatAutocompleteTrigger;
  @ViewChild('examinerAutoCompleteInput', { read: MatAutocompleteTrigger })
  examinerTrigger: MatAutocompleteTrigger;
  @ViewChild('dealerAutoCompleteInput', { read: MatAutocompleteTrigger })
  dealerTrigger: MatAutocompleteTrigger;

  
  ngOnInit(): void {
    this._appService.setPageTitle('Uc Planner');
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this.selectionLists.customerList = result; this.internalLimitedCustomers = result; this.customerCtrl.reset(); });
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this.selectionLists.jobSiteList = result; this.internalLimitedJobSites = result; this.jobsiteCtrl.reset(); });
    // this._appService.getFamilyListForSelection(1, 10000).subscribe(result => {
    //   this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
    //     result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    // });
    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this.selectionLists.makeList = this.filterMakeModelFamilyForExistingOnly ? result.filter(m => m.ExistingCount > 0) : result; this.makeCtrl.reset(); });
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      this.selectionLists.modelList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m);
      this.internalLimitedModels = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m).filter(m => m.ExistingCount > 0) : result.filter(m => m); this.modelCtrl.reset();
    });

    this.loadFavorite();

    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this.filterStates(state) : this.MakeViewModel.slice())
      );

    this.filteredCustomers =
      this.customerCtrl.valueChanges
        .startWith(null)
        .map(customerInput => customerInput ? this.filterCustomers(customerInput) : this.resetCustomer());

    this.filteredJobsites = this.jobsiteCtrl.valueChanges
      .startWith(null)
      .map(jobsiteInput => jobsiteInput ? this.filterJobsites(jobsiteInput) : this.resetJobsite());

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
    this.filteredMakes =
      this.makeCtrl.valueChanges
        .startWith(null)
        .map(makeInput => makeInput ? this.filterMakes(makeInput) : this.resetMake());
    this.filteredModels =
      this.modelCtrl.valueChanges
        .startWith(null)
        .map(modelInput => modelInput ? this.filterModels(modelInput) : this.resetModel());

    this.getUserUOD();

    this.GetGraphHeadings();

    const date = new Date(this.timelineStartDate);
    while (date <= this.timelineEndDate) {
      this.timelineDates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    const barSpan = this.getBarSpan();
    this.emptyColumns = new Array(this.timelineDates.length - barSpan);
  }

  // Table Scroll Fix
  ngAfterViewInit(): void {

    // Wait for Angular to fully render DOM
    setTimeout(() => {
      const scrollableBody = document.querySelector(".scrollable-body") as HTMLElement;
      const stickyHeader = document.querySelector(".sticky-header") as HTMLElement;

      if (!scrollableBody || !stickyHeader) {
        console.warn("Elements not found");
        return;
      }
      scrollableBody.addEventListener("scroll", function () {
        stickyHeader.scrollLeft = scrollableBody.scrollLeft;
      });
    });
  }

  getBarSpan(): number {
    const end = this.barEndDate > this.timelineEndDate ? this.timelineEndDate : this.barEndDate;
    const span = this.timelineDates.findIndex(d =>
      d.toDateString() === end.toDateString()
    );
    return span >= 0 ? span + 1 : 0;
  }
  loadFavorite() {
    this._appService.getUserSearchFavorites(2).subscribe(result => {
      this.userFavorites = result;
      var checkDefaultFav = this.userFavorites.filter(f => f.isDefaultFavourite == true)
      if (checkDefaultFav.length > 0) {
        this.getFavorite(checkDefaultFav[0].Id);
      }
    }, error => console.log(error), () => { });
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  familyDisplayMapper(family: Family) {
    return family ? family.Title : family;
  }

  familySelected(selected, input) {


    this.currentSelection.family.Id = selected.option.value.Id;
    this.currentSelection.family.Title = selected.option.value.Title;
    this.pushMultipleSelection(4, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.familyCtrl.reset();
    this.familyCtrl.setValue(selected.option.value.Title);
  }
  makeDisplayMapper(make: Make) {
    return make ? make.Title : make;
  }

  makeSelected(selected, input) {
    this.currentSelection.make.Id = selected.option.value.Id;
    this.currentSelection.make.Title = selected.option.value.Title;
    this.pushMultipleSelection(5, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 4).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.makeCtrl.reset();
    this.makeCtrl.setValue(selected.option.value.Title)
  }

  filterModels(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      );
    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
        && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);
    return this.selectionLists.modelList.filter(model => model.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
      && this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

  }
  modelSelected(selected, input) {
    if (input)
      input.value = '';
    this.currentSelection.model.Id = selected.option.value.Id;
    this.currentSelection.model.Title = selected.option.value.Title;
    this.pushMultipleSelection(6, selected.option.value.Id, selected.option.value.Title);
    this.modelCtrl.reset();
  }

  resetModel(): Model[] {
    this.currentSelection.model = new Model();
    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model => this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length === 0 && this.multipleSelections.filter(m => m.Id === 5).length > 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);

    if (this.multipleSelections.filter(m => m.Id === 4).length > 0 && this.multipleSelections.filter(m => m.Id === 5).length === 0)
      return this.selectionLists.modelList.filter(model =>
        this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0);

    return this.selectionLists.modelList.filter(model =>
      this.multipleSelections.findIndex(m => m.Id === 6 && (m.SearchId === model.Id || m.SearchStr === model.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === model.FamilyId)) >= 0
      && this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === model.MakeId)) >= 0);
  }
  modelDisplayMapper(model: Model) {
    return model ? model.Title : model;
  }
  resetMake(): Make[] {
    this.currentSelection.make = new Make();
    if (!this.selectionLists.makeList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.makeList.filter(make =>
      (this.multipleSelections.findIndex(m => m.Id === 5 && (m.SearchId === make.Id || m.SearchStr.toLowerCase() === make.Title.toLowerCase())) < 0)
    );

  }

  
  resetFamily(): Family[] {
    // console.log('resetFamily', this.selectionLists.familyList);
    this.currentSelection.family = new Family();
    if (!this.selectionLists.familyList) return [];

    this.internalLimitedModels = this.selectionLists.modelList.filter(model => {
      if (this.multipleSelections.filter(m => m.Id === 5).length > 0)
        return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 5 && (model.MakeId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
      return (this.multipleSelections.findIndex(m => m.Id === 4 && (model.FamilyId === m.SearchId)) >= 0 && this.multipleSelections.findIndex(m => m.Id === 6 && (model.Id === m.SearchId)) < 0);
    });
    this.modelCtrl.reset();
    return this.selectionLists.familyList.filter(family =>
      (this.multipleSelections.findIndex(m => m.Id === 4 && (m.SearchId === family.Id || m.SearchStr.toLowerCase() === family.Title.toLowerCase())) < 0)
    );
  }
  resetJobsite(): JobSite[] {
    // console.log('resetJobsite', this.internalLimitedJobSites);
    this.currentSelection.jobSite = new JobSite();
    if (!this.internalLimitedJobSites) return [];

    this.equipmentCtrl.reset();
    return this.internalLimitedJobSites.filter(jobsite =>
      (this.multipleSelections.findIndex(m => m.Id === 2 && (m.SearchId === jobsite.Id || m.SearchStr.toLowerCase() === jobsite.Title.toLowerCase())) < 0)
    );
  }
  filterMakes(userText: any) {
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.makeList.filter(make =>
      (make.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0)
    );
  }
  filterFamilies(userText: any) {
    // console.log('filterFamilies', this.selectionLists.familyList);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;

    return this.selectionLists.familyList.filter(family =>
      family.Title.toLowerCase().indexOf(txt.toLowerCase())
    );
  }
  filterCustomers(userText: any) {
    // console.log('filterCustomers', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.selectionLists.customerList.filter(cust =>
      cust.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }
  filterJobsites(userText: any) {
    // console.log('filterJobsites', userText);
    let txt = '';
    if (userText.Title)
      txt = userText.Title;
    else txt = userText;
    return this.internalLimitedJobSites.filter(jobsite =>
      jobsite.Title.toLowerCase().indexOf(txt.toLowerCase()) === 0
    );
  }

  jobsiteSelected(selected, input) {
    this.selectedJobsiteForInput.Id = selected.option.value.Id
    this.currentSelection.jobSite.Id = selected.option.value.Id;
    this.currentSelection.jobSite.Title = selected.option.value.Title;
    this.pushMultipleSelection(2, selected.option.value.Id, selected.option.value.Title);
    this.JobSiteforFleetconfiguration.Id = selected.option.value.Id
    this._sharedService.setCustomerInfo(this.JobSiteforFleetconfiguration);

    this.internalLimitedEquipments = this.selectionLists.equipmentList.filter(equipment =>
      this.multipleSelections.findIndex(m => m.Id === 2 && (equipment.JobSiteId === m.SearchId)) >= 0);
    this.filteredEquipments = Observable.of(this.internalLimitedEquipments);


    var customerData = this.multipleSelections.find(x => x.Id == 1);
    let customerid = 0;
    if (customerData != null) {
      customerid = customerData.SearchId;
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    let jobsiteid = 0;
    if (jobSiteData != null) {
      jobsiteid = jobSiteData.SearchId;
    }

    this._appService.getFamilyList(customerid.toString(), jobsiteid.toString()).subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());

    this.jobsiteCtrl.reset();
    this.jobsiteCtrl.setValue(selected.option.value.Title);
  }

  resetFields() {
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
    this.multipleSelections = [];
    this.selectedModel = [];
    this.IsTableShow = false;
    this._appService.getFamilyList('', '').subscribe(result => {
      this.selectionLists.familyList = this.filterMakeModelFamilyForExistingOnly ?
        result.filter(m => m.ExistingCount > 0) : result; this.familyCtrl.reset();
    });

    this.filteredFamilies =
      this.familyCtrl.valueChanges
        .startWith(null)
        .map(familyInput => familyInput ? this.filterFamilies(familyInput) : this.resetFamily());
  }
  equipmentIds: any[] = [];
  GenerateData() {
    this.selectedModel = [];
    this.ucFleetEquipmentDetail = [];
    this.IsTableShow = false;
    this.familyId = 0,
      this.JobsiteId = 0
    this.make_auto = 0
    this.CustomerId = this.multipleSelections.find(x => x.Id == 1).SearchId;
    var familyData = this.multipleSelections.find(x => x.Id == 4);
    if (familyData != null) {
      if (this.familyCtrl.value != '') {
        this.familyId = familyData.SearchId;
      }
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    if (jobSiteData != null) {
      if (this.jobsiteCtrl.value != '') {
        this.JobsiteId = jobSiteData.SearchId;
      }
    }
    var makeData = this.multipleSelections.find(x => x.Id == 5);
    if (makeData != null) {
      if (this.makeCtrl.value != '') {
        this.make_auto = makeData.SearchId;
      }
    }
    var modelData = this.multipleSelections.filter(x => x.Id == 6);
    if (modelData != null) {
      modelData.forEach(element => {
        this.selectedModel.push(element.SearchId)
      });
    }

    if (this.CustomerId > 0) {
      this.FleetTableLoader = true;
      this.ucFleet.CustomerId = this.CustomerId;
      this.ucFleet.FamilyId = this.familyId == 0 ? null : this.familyId;
      this.ucFleet.Jobsiteid = this.JobsiteId == 0 ? null : this.JobsiteId;
      this.ucFleet.MakeId = this.make_auto == 0 ? null : this.make_auto;
      this.ucFleet.Modelid = this.selectedModel == null || this.selectedModel.length == 0 ? null : this.selectedModel.join(',');


      this._planerService.getUcPlannerFleetDetail(this.ucFleet).subscribe(result => {
        this.ucFleetEquipmentDetail = result;
        this.ucFleetEquipmentDetail.forEach(x => (
          this.equipmentIds.push(x.EquipmentId),
          x.IsExpanded = false,
          x.HadApiCall = false,
          x.NextPmDays = x.NextPmDate != null ? this.getDateDifferenceInDays(this.WeekStartDate, x.NextPmDate) : 0,
          x.SecondPmDays = x.NextPmDate != null ? this.getDateDifferenceInDays(this.WeekStartDate, x.SecondPmDate) : 0,
           x.FloatingPm1Days = x.NextPmDate != null ? this.getDateDifferenceInDays(this.WeekStartDate, x.FloatingPm1Date) : 0,
          x.FloatingPm2Days = x.NextPmDate != null ? this.getDateDifferenceInDays(this.WeekStartDate, x.FloatingPm2Date) : 0,
          x.Summary.forEach(sum => {
            sum.ActionDateDays = this.getDateDifferenceInDays(this.WeekStartDate, sum.ActionDate)
          })
        ));
        console.log(this.ucFleetEquipmentDetail)

        this.GetHeaderInfoData();
        this.FleetTableLoader = false;
        this.IsTableShow = true;
      })
    } else {
      this._notify.warn("Select Customer")
    }
  }

  isPopupOpen = false;
  selectedValues: any[] = [];

  receiveSelectedCheckboxes(selectedCheckboxes: any[]) {
    this.selectedValues = selectedCheckboxes;
  }
  selectedValuesToSend: any[] = []
  ColumnList: ColumnList = new ColumnList();
  HasSummaryTrackRoller: boolean = false;
  HasSummaryRolling: boolean = false;
  userFavorites: SearchFavorite[] = [];

  DisplaySettingsPopup(value: number, favourite?: any, QuoteId?: number, date?: string, componentid?: number, equipmentId?: number, smu?: number) {
    // this.CustomerId = this.multipleSelections.find(x => x.Id == 1).SearchId;
    let customerid = 0;
    let jobsiteid = 0
    var customerdata = this.multipleSelections.find(x => x.Id == 1);
    if (customerdata != null) {
      if (this.customerCtrl.value != '') {
        customerid = customerdata.SearchId;
      }
    }

    var jobSiteData = this.multipleSelections.find(x => x.Id == 2);
    if (jobSiteData != null) {
      if (this.jobsiteCtrl.value != '') {
        jobsiteid = jobSiteData.SearchId;
      }
    }
    const dialogRef = this._dialog.open(DisplaySettingsPopupComponent, {
      width: "300px",
      data: {
        PopupFor: value,
        selectedValues: this.selectedValues,
        selectedColumns: this.ColumnList,
        customerId: customerid,
        jobsiteid: jobsiteid,
        Favourite: favourite,
        QuoteId: QuoteId,
        date: date,
        componentid: componentid,
        equipmentId: equipmentId,
        smu: smu,
      }

    });
    dialogRef.afterClosed().subscribe(selectedCheckboxes => {
      this.HasSummaryTrackRoller = false;
      this.HasSummaryRolling = false;
      if (selectedCheckboxes) {

        if (value == 4) {

          this.UcPlannerGrapVm.Data = new UcPlannerGrapCompVm();
          this.selectedValues = selectedCheckboxes;
          var trackdata = this.selectedValues.find(x => x == 102);
          if (trackdata != null && trackdata != undefined) {
            this.HasSummaryTrackRoller = true;
          }

          var rollerData = this.selectedValues.find(x => x == 101);
          if (rollerData != null && rollerData != undefined) {
            this.HasSummaryRolling = true;
          }

          if (this.selectedValues.length > 0) {
            //this.ucFleetEquipmentDetail = [];
            this.ucFleetEquipmentDetail.forEach(x => {
              x.UCPlannerComponent=[];
              x.GraphData=[];
              this.toggleExpansion(x, 0);
            })
          }
        } else if (value == 6 || value == 15 || value == 16) {
          const fav = new favPopUpModel();
          fav.SearchFavorite = selectedCheckboxes.SearchFavorite;

          fav.SearchFavorite.SearchItems.push(...this.multipleSelections);
          if (selectedCheckboxes.operation == FavOperation.Add) {
            this._appService.addSearchFavorite(fav.SearchFavorite).subscribe(result => {
              if (!result.ResultMessage.OperationSucceed) {
                alert(this.Translate('result.ResultMessage.LastMessage'));
              }
              this.userFavorites = [];
              this.userFavorites.push(...result.SearchFavorites);
            }, error => console.error(error));
          } else if (selectedCheckboxes.operation == FavOperation.Update) {
            fav.SearchFavorite.SearchItems = [];
            fav.SearchFavorite.SearchItems.push(...this.multipleSelections);
            this._appService.updateSearchFavorite(fav.SearchFavorite).subscribe(result => {
              if (!result.ResultMessage.OperationSucceed) {
                alert(this.Translate(result.ResultMessage.LastMessage));
              }
              this.userFavorites = [];
              this.loadFavorite();
            }, error => console.error(error));
          } else {
            this._appService.removeSearchFavorite(fav.SearchFavorite).subscribe(removeResult => {
              if (!removeResult.ResultMessage.OperationSucceed) {
                alert(this.Translate('result.ResultMessage.LastMessage'));
              }
              this.userFavorites = [];
              this.loadFavorite();
            }, error => console.error(error));
          }
        } else if (value == 2) {
          this.GenerateData();
          this.GetGraphHeadings();
        } else if (value == 5)
          this.intervel = selectedCheckboxes;
        else
          this.ColumnList = selectedCheckboxes;
      }
    });
  }
  selectedRow: number = null;
  componentLoader: boolean;
  graphLoader: boolean;
  intervel: number = 1;
  NextPmDays: number;
  SecondPmDays: number;
  toggleExpansion(item: any, value: number) {
    console.log(this.ucFleetEquipmentDetail);
    if (item.NextInspectionDate != null || item.NextInspectionDate != '') {
      item.NextPmDays = this.getDateDifferenceInDays(this.WeekStartDate, item.NextPmDate);
    }
    if (item.SecondPmDate != null || item.SecondPmDate != '') {
      item.SecondPmDays = this.getDateDifferenceInDays(this.WeekStartDate, item.SecondPmDate);
     // console.log(this.SecondPmDays, this.NextPmDays);
    }

    if (this.selectedValues.length == 0 || value == 1) {
      item.IsExpanded = !item.IsExpanded;

      if (!item.HadApiCall) {
        this.componentLoader = true;

        this._planerService.GetUcPlannerComponentDetail(item.EquipmentId, this.selectedValues).subscribe(result => {
          item.UCPlannerComponent = result;
          item.HadApiCall = true;
          console.log(this.ucFleetEquipmentDetail);
          //item.IsExpanded=true;
          this.componentLoader = false;
          this.LoadEvalautionForEquipment(item.EquipmentId);
        })

        this.GetGraphData(item);
        this.UcPlannerGraphHeadingsBudget(item);
        this.Month

      }
    } else {
      if (!item.IsExpanded) {
        item.IsExpanded = !item.IsExpanded;
      }
      if (this.selectedValues.length > 0) {

        this.componentLoader = true;
        this._planerService.GetUcPlannerComponentDetail(item.EquipmentId, this.selectedValues).subscribe(result => {
          item.UCPlannerComponent = result;
          item.HadApiCall = true;
          //item.IsExpanded=true;
          this.componentLoader = false;
          this.LoadEvalautionForEquipment(item.EquipmentId);
          this.GetGraphData(item);
          this.UcPlannerGraphHeadingsBudget(item);
        })
        // }
      }
    }
    // If clicking the same row that is expanded, collapse it. Otherwise, expand the new row.
  }

  GetEvalColour(compType, worn: number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';

    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';


      default:
        break;
    }
  }

  EvalautionRange: CustomeEvaluationRangeVM;
  LoadEvalautionForEquipment(equipmentid: number) {
    this._evalService.GetSelectedLevelRangesForSelectedEquipment(equipmentid).subscribe(res => {
      this.EvalautionRange = res;
    })
  }

  NavigateToSearch(value: number) {
    if (value === 2) {
      window.open('/search-action-recommendation', '_blank');
    } else {
      window.open('/smu-pm-service', '_blank');
    }
  }

  selectedModels = [];
  selectedModel: number[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  // Remove model from selected list
  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);

      this.selectedModels.splice(index, 1);

    }
  }

  stateCtrl: FormControl;
  filteredStates: Observable<any[]>;
  filterStates(name: string) {
    return this.MakeViewModel.filter(state =>
      state.Makedesc.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  multipleSelections: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: 'Evaluation X' }];

  getPushedSelections(itemId): SearchItem[] {
    let arr = this.multipleSelections.filter(m => m.Id === itemId);

    return arr
  }


  focus(item) {
    switch (item) {
      case 1:
        this.customerTrigger.openPanel();
        break;
      case 2:
        this.jobSiteTrigger.openPanel();
        break;
      case 3:
        this.equipmentTrigger.openPanel();
        break;
      case 4:
        this.familyTrigger.openPanel();
        break;
      case 5:
        this.makeTrigger.openPanel();
        break;
      case 6:
        this.modelTrigger.openPanel();
        break;
      case 20:
        this.examinerTrigger.openPanel();
        break;
      case 21:
        this.dealerTrigger.openPanel();
        break;
    }
  }
  selectionLists: SelectionLists = new SelectionLists();
  selectedJobsiteForInput: JobSite = new JobSite();
  currentSelection: CurrentSelection = new CurrentSelection();

  customerDisplayMapper(customer: Customer) {
    return customer ? customer.Title : customer;
  }
  jobsiteDisplayMapper(jobsite: JobSite) {
    return jobsite ? jobsite.Title : jobsite;
  }
  JobSiteforFleetconfiguration: JobSite = new JobSite()

  customerSelected(selected, input) {
    this.selectedJobsiteForInput.CustomerId = selected.option.value.Id
    this.currentSelection.customer.Id = selected.option.value.Id;
    this.currentSelection.customer.Title = selected.option.value.Title;
    //fleet configuration filter
    this.JobSiteforFleetconfiguration.CustomerId = selected.option.value.Id;
    //this._share
    // 
    // dService.setCustomerInfo(this.JobSiteforFleetconfiguration);
    this.pushMultipleSelection(1, selected.option.value.Id, selected.option.value.Title);
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);

    this.customerCtrl.reset();
    this.customerCtrl.setValue(selected.option.value.Title)
  }

  pushMultipleSelection(itemId: number, searchId: number, searchText: string): void {

    if ((searchId === 0 && searchText.length === 0))
      return;
    console.log('itemId ' + itemId + '  search Id ' + searchId + ' searvh text ' + searchText)
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;

    // If the item isn't a date
    if (itemId !== 12 && itemId !== 13 && itemId !== 22 && itemId !== 23) {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
      if (index >= 0 && itemId !== 20) return;
    } else if (itemId == 22) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 22);
    }
    else if (itemId == 23) {
      this.multipleSelections = this.multipleSelections.filter(x => x.Id != 23);
    }
    else {
      const index = this.multipleSelections.findIndex(m => m.Id === itemId);
      this.multipleSelections.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId; item.SearchStr = searchText; item.Title = searchText;

    if (itemId == 1) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 2) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 4) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    } else if (itemId == 5) {
      this.multipleSelections = this.multipleSelections.filter(m => m.Id !== itemId);
      this.multipleSelections.push(item);
    }
    else {
      this.multipleSelections.push(item);
    }
  }

  resetCustomer(): Customer[] {
    // console.log('resetCustomer');
    this.currentSelection.customer = new Customer();
    this.internalLimitedJobSites = this.selectionLists.jobSiteList.filter(jobsite =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (jobsite.CustomerId === m.SearchId)) >= 0);
    this.jobsiteCtrl.reset();

    if (this.multipleSelections.filter(m => m.Id === 21).length === 0)
      return this.selectionLists.customerList.filter(cust => this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0);

    if (this.multipleSelections.filter(m => m.Id === 21).length > 0)
      return this.selectionLists.customerList.filter(cust =>
        this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
        && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);

    return this.selectionLists.customerList.filter(cust =>
      this.multipleSelections.findIndex(m => m.Id === 1 && (m.SearchId === cust.Id || m.SearchStr === cust.Title)) < 0
      && this.multipleSelections.findIndex(m => m.Id === 21 && (m.SearchId === cust.DealerId)) >= 0);
  }
  popMultipleSelection(itemId: number, searchId: number, searchText: string) {
    if (searchId === 0 && searchText.length === 0)
      return;
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;
    const index = this.multipleSelections.findIndex(m => m.Id === itemId && (m.SearchId === searchId || m.SearchStr.toLowerCase() === searchText.toLowerCase()));
    if (index < 0) return;
    this.multipleSelections.splice(index, 1);
    this.resetControlBySearchId(itemId);

  }
  resetControlBySearchId(itemId: number): void {
    switch (itemId) {
      case 1: // 1 -> Customer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        break;
      case 2: // 2 -> Jobsite
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
        // this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        break;
      case 3: // 3 -> Equpment
        this.equipmentCtrl.reset();
        //this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
        break;
      case 4: // 4 -> Family
        this.familyCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 5: // 5 -> Make
        this.makeCtrl.reset();
        this.modelCtrl.reset();
        break;
      case 6: // 6 -> Model
        this.modelCtrl.reset();
        break;
      case 20: // 20 -> Examiner
        //this.examinerCtrl.reset();
        break;
      case 21: // 21 -> Dealer
        this.customerCtrl.reset();
        this.jobsiteCtrl.reset();
        this.equipmentCtrl.reset();
      // this.dealerCtrl.reset();
    }
  }
  getFavorite(favId: number) {
    this._appService.getFavoriteItems(favId).subscribe(result => {
      this.resetSelection();
      this.multipleSelections.push(...result);
      this.submitSelection();
    }, error => console.error(error));
  }

  resetSelection() {
    this.multipleSelections = [
      { Id: 8, SearchId: 1, SearchStr: '', Title: 'Evaluation A' },
      { Id: 9, SearchId: 1, SearchStr: '', Title: 'Evaluation B' },
      { Id: 10, SearchId: 1, SearchStr: '', Title: 'Evaluation C' },
      { Id: 11, SearchId: 1, SearchStr: '', Title: 'Evaluation X' },
    ];
    this.filteredCustomers = Observable.of(this.selectionLists.customerList);
    this.filteredJobsites = Observable.of(this.selectionLists.jobSiteList);
    this.filteredFamilies = Observable.of(this.selectionLists.familyList);
    this.filteredMakes = Observable.of(this.selectionLists.makeList);
    this.filteredModels = Observable.of(this.selectionLists.modelList);
    this.filteredEquipments = Observable.of(this.selectionLists.equipmentList);
    this.filteredExaminers = Observable.of(this.selectionLists.examinerList);
    this.filteredDealer = Observable.of(this.selectionLists.dealerList);

    this.internalLimitedJobSites = this.selectionLists.jobSiteList;
    this.internalLimitedModels = this.selectionLists.modelList;
    this.internalLimitedEquipments = this.selectionLists.equipmentList;
    this.selectedComponentType = 0;

    this.internalLimitedCustomers = this.selectionLists.customerList;
    this.customerCtrl.reset();
    this.jobsiteCtrl.reset();
    this.makeCtrl.reset();
    this.modelCtrl.reset();
    this.familyCtrl.reset();
  }


  submitSelection(): void {

    this.currentSelection = new CurrentSelection();
    const firstCustomer = this.multipleSelections.find(m => m.Id === 1);
    if (firstCustomer) {
      this.currentSelection.customer.Id = firstCustomer.Id;
      this.currentSelection.customer.Title = firstCustomer.Title;
      this.customerCtrl.setValue(firstCustomer.Title)
      this.CustomerId = firstCustomer.Id;
    }

    const firstJobsite = this.multipleSelections.find(m => m.Id === 2);
    if (firstJobsite) {
      this.currentSelection.jobSite.Id = firstJobsite.Id;
      this.currentSelection.jobSite.Title = firstJobsite.Title;
      this.jobsiteCtrl.setValue(firstJobsite.Title)
      this.JobsiteId = firstJobsite.Id;
    }

    const firstFamily = this.multipleSelections.find(m => m.Id === 4);
    if (firstFamily) {
      this.currentSelection.family.Id = firstFamily.Id;
      this.currentSelection.family.Title = firstFamily.Title;
      this.familyCtrl.setValue(firstFamily.Title)
      this.familyId = firstFamily.Id;
    }
    const firstMake = this.multipleSelections.find(m => m.Id === 5);
    if (firstMake) {
      this.currentSelection.make.Id = firstMake.Id;
      this.currentSelection.make.Title = firstMake.Title;

      this.makeCtrl.setValue(firstMake.Title)
      this.make_auto = firstMake.Id;
    }
    const firstModel = this.multipleSelections.find(m => m.Id === 6);
    if (firstModel) {
      this.currentSelection.model.Id = firstModel.Id;
      this.currentSelection.model.Title = firstModel.Title;
    }
  }
  isPopupVisible = false;

  openPopup() {
    this.isPopupVisible = true;
  }
  //TT-9235
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
  exportCSVClicked() {
    this.downloadFile(this.ucFleetEquipmentDetail)
  }

  downloadFile(data: any) {
    let _data = []
    data.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {
          if (key == "Make") {
            _o["Make"] = p[key]
          } else if (key == "Model") {
            _o["Model"] = p[key]
          } else if (key == "Unit") {
            _o["Unit"] = p[key]
          } else if (key == "SMU") {
            _o["SMU"] = p[key]
          } else if (key == "LTD") {
            _o["LTD"] = p[key]
          }
          else if (key == "LastInspectionWorn") {
            _o["LastInspectionWorn"] = ""
          } else if (key == "SMUDOELastInspection") {
            _o["SMUDOELastInspection"] = ""
          }
          else if (key == "WornPercentageToday") {
            _o["WornPercentageToday"] = ""
          }
          else if (key == "SMUDOEToday") {
            _o["SMUDOEToday"] = ""
          }
          else if (key == "WornAtNextPmService") {
            _o["WornAtNextPmService"] = ""
          }
          else if (key == "SMUDOENextInspection") {
            _o["SMUDOENextInspection"] = ""
          }
          else if (key == "WornAtSecondPmService") {
            _o["WornAtSecondPmService"] = ""
          } else if (key == "SMUDOESecondInspection") {
            _o["SMUDOESecondInspection"] = ""
          }
          else if (key == "DateAt100Worn") {
            _o["DateAt100Worn"] = ""
          } else if (key == "DateAt120Worn") {
            _o["DateAt120Worn"] = ""
          }
        }
      }
      _data.push(_o)


      if (p.UCPlannerComponent && p.UCPlannerComponent.length > 0) {
        p.UCPlannerComponent.forEach(component => {
          let componentRow: any = {
            Make: '', // equipment details empty to visually indicate it's a child row
            Model: '',
            Unit: '',
            SMU: component.CompartName,
            LTD: '',
            LastInspectionWorn: component.LastInspectionWorn + '%',
            SMUDOELastInspection: component.LastInspectionSmu + "/" + component.LastInspectionDoe,
            WornPercentageToday: component.WornPercentageToday + '%',
            SMUDOEToday: component.WornPercentageTodaySmu + "/" + component.WornPercentageTodayDoe,
            WornAtNextPmService: component.WornAtNextPmService + '%',
            SMUDOENextInspection: component.SMUAtNextPm + "/" + component.DOCAtNextPm,
            WornAtSecondPmService: component.WornAtSecondPmService + '%',
            SMUDOESecondInspection: component.SMUAtSecondPm + "/" + component.DOCAtSecondPm,
            DateAt100Worn: this.datePipe.transform(component.DateAt100Worn, 'dd MMM yyyy'),
            DateAt120Worn: this.datePipe.transform(component.DateAt120Worn, 'dd MMM yyyy'),
            ComponentName: '',
            ComponentId: '',
            ComponentHours: ''
          };
          _data.push(componentRow);
        })
      }
    })
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = `UcPlanner.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();

  }

  GetGraphData(item: any) {
    this.graphLoader = true;
    this._planerService.GetUcPlannerGraphDetail(item.EquipmentId, this.selectedValues).subscribe(result => {
      this.UcPlannerGrapVm = result;

      this.UcPlannerGrapVm.Data.GraphData.forEach(element => {
        element.DaysForRecommArr = [];
        element.DaysFor100 = this.getDateDifferenceInDays(this.WeekStartDate, element.Date100PercentWorn);
        element.DaysFor100Arr = Array.from({ length: element.DaysFor100 }, (_, i) => i + 1);
        element.TodayDateDays = this.getDateDifferenceInDays(this.WeekStartDate, new Date());
        element.DaysFor120 = this.getDateDifferenceInDays(this.WeekStartDate, element.Date120PercentWorn);
        element.DaysFor120Arr = Array.from({ length: element.DaysFor120 - element.DaysFor100 }, (_, i) => i + (element.DaysFor100 + 1));
        element.QuoteData.forEach(quotedata => {
          element.DaysForRecommA = this.getDateDifferenceInDays(this.WeekStartDate, quotedata.ActionDate);
          if (element.DaysForRecommA > 0) {
            element.DaysForRecommArr.push({ Days: element.DaysForRecommA, Date: quotedata.ActionDate, QuoteId: quotedata.QuoteAuto, ComponentId: quotedata.ComponentId, Smu: quotedata.StartActionAtSmu, ActionDescription: quotedata.ActionDescription });
            element.CalcualtedDateForRecom = this.calculateNextActionDate(quotedata.ActionDate, 20, quotedata.StartActionAtSmu);
            if (quotedata?.ActionDescription?.toLocaleLowerCase().includes('replace')) {
              element.DaysForReplacement = this.getDateDifferenceInDays(quotedata.ActionDate, element.CalcualtedDateForRecom);
              let Diff: number = this.getDateDifferenceInDays(this.WeekStartDate, quotedata.ActionDate);
              element.DaysForNextReplacementRecommArr = Array.from({ length: element.DaysForReplacement }, (_, i) => i + (Diff));
            }
          }
        });
      });
      item.GraphData = this.UcPlannerGrapVm.Data.GraphData.filter(g => g.EquipmentId === item.EquipmentId);
      this.buildBarClassMap();
      this.buildRecommendationMap();
      console.log("item.GraphData", item.GraphData);
      this.graphLoader = false;

    })
  }
  calculateNextActionDate(actionDate: string | Date, avgUsageHours: number, smu: number): Date | null {
    if (!avgUsageHours || avgUsageHours <= 0 || !smu || smu <= 0 || !actionDate) {
      return null;
    }
    const parsedDate = new Date(actionDate);
    if (isNaN(parsedDate.getTime())) {
      console.error('Invalid action date');
      return null;
    }
    const daysToAdd = Math.round(smu / avgUsageHours);
    parsedDate.setDate(parsedDate.getDate() + daysToAdd);

    return parsedDate;
  }
  UcPlannerGrapHeadingsVm: UcPlannerGrapHeadingsVm;
  GraphHeaderData: GraphHeaderData[] = [];

  GetGraphHeadings() {
    this._planerService.UcPlannerGraphHeadings().subscribe(result => {
      this.UcPlannerGrapHeadingsVm = result;
      this.GraphHeaderData = this.UcPlannerGrapHeadingsVm.Data;
      this.getWeekDateRangeDifference(this.UcPlannerGrapHeadingsVm.Data);
      const seen = new Set<string>();
      this.uniqueMonths = this.UcPlannerGrapHeadingsVm.Data
        .filter((item: any) => {
          const key = `${item.MonthName}-${item.YearNo}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .map((item: any) => ({
          MonthName: item.MonthName,
          YearNo: item.YearNo,
          Monthlybudget: null
        }));
    })
    console.log(this.uniqueMonths)
  }

 
  getWeekDateRangeDifference(data: GraphHeaderData[]): number {
    if (!data || data.length === 0) return 0;

    // Convert start and end dates to Date objects
    const startDate = new Date(data[0].WeekStart);
    const endDate = new Date(data[data.length - 1].WeekEnd);
    this.WeekStartDate = startDate;
    this.GetTodayDateDays();
    // Calculate difference in days
    const diffTime = endDate.getTime() - startDate.getTime();
    this.TotalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert milliseconds to days
    this.DaysArr = Array(this.TotalDays).fill(0).map((_, i) => i + 1)
    console.log(this.TotalDays);
    console.log(this.DaysArr);
    return this.TotalDays;
  }

  todayDayDiff: number;
  GetTodayDateDays() {
    this.todayDayDiff = this.getDateDifferenceInDays(this.WeekStartDate, new Date());

  }

  getDateDifferenceInDays(startDate: string | Date, endDate: string | Date): number {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Normalize both dates (remove time part)
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const diffTime = end.getTime() - start.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays + 1;
  }



  getBarClass(day: number, element: any): string {
    let _className: string = '';
    const componentData =
      this.ucFleetEquipmentDetail
        ?.find(x => x.EquipmentId === element.EquipmentId)
        ?.GraphData
        ?.find(
          (item: any) =>
            item.EquipmentId === element.EquipmentId &&
            item.EqunitAuto === element.EqunitAuto
        );
    if (componentData) {
      if (componentData.DaysForNextReplacementRecommArr?.includes(day)) {
        return 'bar-Recom';
      }
      if (componentData.DaysFor100Arr?.includes(day)) {
        _className = 'bar-100';
      }
      else if (componentData.DaysFor120Arr?.includes(day)) {
        _className = 'bar-120';
      }
    }

    return _className; // no class if day doesn't exist in any array
  }

  getRecommendationedArrayForCompoenent(day: number, element: any): any[] {
    return (
      this.UcPlannerGrapVm
        ?.Data
        ?.GraphData
        ?.find(
          (item: any) =>
            item.EquipmentId === element.EquipmentId &&
            item.EqunitAuto === element.EqunitAuto
        )
        ?.DaysForRecommArr
        ?.filter((q: any) => q.Days === day)
    ) || [];
  }

  getRecommendation(day: number, element: any): boolean {
    if (element.DaysForRecommArr?.some((item: any) => item.Days === day)) {
      return true;
    }
    return false;
  }
  MonthlyQuoteSummaryVM: MonthlyQuoteSummaryVM = new MonthlyQuoteSummaryVM();
  Month: MonthlyQuoteSummary[];
  Weekly: WeeklyQuoteSummary[];

  GetHeaderInfoData() {
    this._planerService.UcPlannerGraphHeadingsBudget(this.equipmentIds.join(',')).subscribe(result => {
      if (result.Status == 1) {
        this.Month = result.Month;
        this.Weekly = result.Weekly;
        this.GraphHeaderData.forEach(x => {
          this.Weekly.forEach(w => {
            if (x.WeekNo == w.WeekNo && x.YearNo == w.WeekYear) {
              x.WeekLyBudget = w.TotalWeekPrice
            }
          })
        });

        this.Month.forEach(y => {
          this.uniqueMonths.forEach(x => {
            if (x.MonthName == y.MonthName && x.YearNo == y.YearNo) {
              x.MonthlyBudget = y.TotalMonthPrice
            }
          })
        })
      }
    });
  }

  UcPlannerGraphHeadingsBudget(item: any) {
    this._planerService.UcPlannerGraphHeadingsBudget(item.EquipmentId).subscribe(result => {
      if (result.Status == 1) {

        item.Weekly = result.Weekly;
        console.log(this.ucFleetEquipmentDetail);
      }
    });
  }

  OpenSettingForecast(item, LastInspectionId: number, unitno: string) {
    const dialogRef = this._dialog.open(ForecastSettingPopupComponent, {
      width: "1800px",
      disableClose: true,
      data: {
        inspectionId: LastInspectionId,
        unitno: unitno
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GenerateData();
        this.toggleExpansion(item, 1)
      }
    });
  }

  NavigateToInterpretation(inspectionID: number) {
    window.open(`/interpretation/${inspectionID}`, '_blank');
  }
  barClassMap = new Map<string, Set<number>>();

  buildBarClassMap() {
    this.ucFleetEquipmentDetail?.forEach((eq: any) => {
      eq.GraphData?.forEach((g: any) => {
        const key = `${g.EquipmentId}_${g.EqunitAuto}`;
        const set = new Set<number>();
        g.DaysForNextReplacementRecommArr?.forEach((d: number) => set.add(d * 10 + 1));
        g.DaysFor100Arr?.forEach((d: number) => set.add(d * 10 + 2));
        g.DaysFor120Arr?.forEach((d: number) => set.add(d * 10 + 3));
        this.barClassMap.set(key, set);
      });
    });
  }

getTooltip(value: string | null | undefined): string {
  return this.splitByComma(value).join('\n');
}
splitByComma(value: string | null | undefined): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map(x => x.trim())
    .filter(x => x.length > 0);
}

  buildRecommendationMap() {
    this.UcPlannerGrapVm?.Data?.GraphData?.forEach((g: any) => {
      const key = `${g.EquipmentId}_${g.EqunitAuto}`;
      const dayMap = new Map<number, any[]>();

      g.DaysForRecommArr?.forEach((d: any) => {
        if (!dayMap.has(d.Days)) {
          dayMap.set(d.Days, []);
        }
        dayMap.get(d.Days)!.push(d);
      });

      this.recommendationMap.set(key, dayMap);
    });
  }
  getRecommendationsFast(day: number, element: any): any[] {
    const key = `${element.EquipmentId}_${element.EqunitAuto}`;
    return this.recommendationMap.get(key)?.get(day) || [];
  }
  getBarClassFast(day: number, element: any): string {
    const key = `${element.EquipmentId}_${element.EqunitAuto}`;
    const set = this.barClassMap.get(key);
    if (!set) return '';
    if (set.has(day * 10 + 1)) return 'bar-Recom';
    if (set.has(day * 10 + 2)) return 'bar-100';
    if (set.has(day * 10 + 3)) return 'bar-120';
    return '';
  }

  getFilteredGraphData(item1: any) {
    if (!item1 || !item1.GraphData || !item1.EqunitId) {
      return [];
    }

    return item1.GraphData.filter(
      (g: any) => g.EqunitId === item1.EqunitId
    );
  }
  getLeftPosition(column: number): number {
  let left = 0;

  if (column >= 2) left += 60; // col1 always exists

  if (column >= 3 && this.ColumnList.Make) left += 140;

  if (column >= 4) left += 100;

  if (column >= 5) left += 114;

  return left;
}
}
